import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import type { RootState, AppDispatch } from 'store/store'

/*
* Customize the useDispatch and useSelector hooks from react-redux to use TypeScript types for the application's dispatch function and state.
* This means we don't have to repeatedly specify the types of the store's state and dispatch function whenever we use these hooks throughout the app.
* Use these custom store hooks throughout the app instead of plain `useDispatch` and `useSelector`
* */
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
